import { twMerge } from 'tailwind-merge';

import { BasicButton } from 'routes/staking_v2/components/BasicButton';

import { STATUS_CONFIG } from './constants';
import { TaskItemProps } from './types';

type StatusFooterProps = Pick<TaskItemProps, 'status' | 'endsIn' | 'onRegister' | 'onClaim'>;

export const StatusFooter = ({ status, endsIn, onRegister, onClaim }: StatusFooterProps) => {
  const config = STATUS_CONFIG[status];

  if (status === 'available') {
    return (
      <div className="tw-flex tw-items-center tw-justify-between">
        {endsIn && <span className="tw-text-[12px] tw-font-semibold tw-text-[#20AA67]">Ends in: {endsIn}</span>}
        <BasicButton text="Register" onClick={onRegister} className="tw-h-[36px] tw-min-w-[83px]" />
      </div>
    );
  }

  if (status === 'claimable') {
    return (
      <div className="tw-flex tw-items-center tw-justify-between">
        {endsIn && <span className="tw-text-[12px] tw-font-semibold tw-text-[#20AA67]">Ends in: {endsIn}</span>}
        <BasicButton text="Claim" onClick={onClaim} className="tw-h-[36px] tw-min-w-[83px]" />
      </div>
    );
  }

  return (
    <div className="tw-flex tw-items-center tw-justify-between">
      <span
        className={twMerge(
          'tw-py-[2px] tw-text-[12px] tw-font-semibold tw-uppercase tw-leading-none',
          config.statusColor
        )}
      >
        {status === 'in_distribution' || status === 'in_progress'
          ? endsIn
            ? `Ends in: ${endsIn}`
            : 'Status:'
          : 'Status:'}
      </span>
      <div
        className={twMerge(
          'tw-flex tw-h-[30px] tw-min-w-[105px] tw-items-center tw-justify-center tw-rounded-[6px] tw-px-[10px]',
          config.badgeColor
        )}
      >
        <span className="tw-text-[16px] tw-font-bold tw-text-white">{config.badgeText}</span>
      </div>
    </div>
  );
};
